import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    configuration: {
        uuid: "",
        warna: "bg-orange",
        dark: "",
        head: "",
        text: "text-orange",
        hexColor: "",
        hexDarkColor: "",
        splash: "",
        nomorKTP: "",
        alias: "",
        latitude: "",
        longitude: "",
        altitude: "",
        namaLokasi: ""
    },
    param: {
        sn: '',
        guid: ''
    },
    navigasi: "",
    tipeListBuku: "",
    bottomIndex: 0,
    youtube: {
        expire: 0,
        data: [],
    },
    search: ""
};

const parameterSlice = createSlice({
    name: "parameter",
    initialState,
    reducers: {
        setConfiguration: (state, action) => {
            state.configuration = action.payload;
        },
        setNavigasi: (state, action) => {
            state.navigasi = action.payload;
        },
        setTipeListBuku: (state, action) => {
            state.tipeListBuku = action.payload;
        },
        setBottomIndex: (state, action) => {
            state.bottomIndex = action.payload;
        },
        setYoutube: (state, action) => {
            state.youtube = action.payload;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        setParam: (state, action) => {
            state.param = action.payload;
        }
    }
});

// Selectors
export const configuration = (state) => state.parameter.configuration;
export const navigasi = (state) => state.parameter.navigasi;
export const tipeListBuku = (state) => state.parameter.tipeListBuku;
export const bottomIndex = (state) => state.parameter.bottomIndex;
export const youtube = (state) => state.parameter.youtube;
export const search = (state) => state.parameter.search;
export const param = (state) => state.parameter.param;

// Actions & Reducer
export const {
    setConfiguration,
    setNavigasi,
    setTipeListBuku,
    setBottomIndex,
    setYoutube,
    setSearch,
    setParam,
} = parameterSlice.actions;

export default parameterSlice.reducer;
